module.exports = __webpack_public_path__ + "img/logo-8.761941dc.svg";